import { gql } from "@apollo/client";

export const UPDATE_ACCOUNT_TYPE = gql`
  mutation updateAccountType(
    $account_uuid: String!
    $account_type: AccountType!
  ) {
    cnc_update_account_type(
      account_uuid: $account_uuid
      account_type: $account_type
    ) {
      ok
      msg
    }
  }
`;
